import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PartnerPendingStore, PartnerPendingState } from './partner-pending.store';

@Injectable({ providedIn: 'root' })
export class PartnerPendingQuery extends QueryEntity<PartnerPendingState> {

  constructor(protected store: PartnerPendingStore) {
    super(store);
  }

}
